import React from "react";
import "./PurchaseLimitAlertTile.scss";
import getTranslationData from "../../TranslationUtility/TranslationUtility";

const PurchaseLimitAlertTile = (props) => {
    const translatipn = getTranslationData();
   const formattedMessage = translatipn.purchase_limit_alert
   .replace("{timePeriod}", props.timePeriod)
    .replace("{amount}", props.amount)
    .replace("{name}", props.name)
    .replace("{time}", props.reset_text);
  return (
    <div className="d-flex align-items-center mt-3 p-3 monthly-limit-box">
      <i className="fa-solid fa-triangle-exclamation mr-2 purchase-limit-icon"></i>
       <span
      className="monthly-limit-text"
      dangerouslySetInnerHTML={{ __html: formattedMessage }}
    />
    </div>
  );
};

export default PurchaseLimitAlertTile;
